import type { MonetizationRequestContextResponse } from '../services/GuaranteesService';

export type PrefilledMonetizationEntry = 'gda' | 'monetization';

export function buildPrefilledMonetizationSearchParams(
  context: MonetizationRequestContextResponse,
  extras?: { from?: PrefilledMonetizationEntry },
): URLSearchParams {
  const params = new URLSearchParams({
    cuit: context.cuit,
    companyName: context.companyName || '',
    productId: String(context.productId),
    productLineCode: context.productLineCode,
    productLabel: context.productLabel,
    currencyId: String(context.currencyId),
    currencyCode: context.currencyCode,
    effectiveCapacity: String(context.effectiveCapacity),
    availableOperable: String(context.availableOperable),
    availableProduct: String(context.availableProduct),
    availableCuitCurrency: String(context.availableCuitCurrency),
    applicationProductLineId: context.applicationProductLineId
      ? String(context.applicationProductLineId)
      : '',
    prefilled: 'true',
  });

  if (extras?.from) {
    params.set('from', extras.from);
  }

  return params;
}

export function buildGroupedGdaReturnPath(
  cuit: string,
  productId: string | number,
  currencyId: string | number,
): string {
  return `/avales/${cuit}/agrupado/${productId}/${currencyId}`;
}

export function resolvePrefilledBackPath(
  from: string | null,
  searchParams: {
    cuit: string | null;
    productId: string | null;
    currencyId: string | null;
  },
  prefilledData?: {
    cuit?: string;
    productId?: number;
    currencyId?: number;
  } | null,
): string | null {
  if (from !== 'gda') {
    return null;
  }

  const returnCuit = searchParams.cuit || prefilledData?.cuit;
  const returnProductId =
    searchParams.productId ||
    (prefilledData?.productId != null ? String(prefilledData.productId) : '');
  const returnCurrencyId =
    searchParams.currencyId ||
    (prefilledData?.currencyId != null ? String(prefilledData.currencyId) : '');

  if (!returnCuit || !returnProductId || !returnCurrencyId) {
    return null;
  }

  return buildGroupedGdaReturnPath(returnCuit, returnProductId, returnCurrencyId);
}
